import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { CancelIcon } from '@deliveryhero/armor-icons';
import { useComponentTheme } from '../../utils/hooks';
import { useMessageClassNames } from './utils/useMessageClassNames';
import { MessageRoot, MessageIconStyle, MessageCentral, MessageCloseButton, MessageContent, MessageActions, MessageExtra } from './style';
import { useIconComponent } from './utils/useIconComponent';
import { MESSAGE_CLASS_PREFIX } from './constants';
export var Message = function Message(_ref) {
  var className = _ref.className,
      onClose = _ref.onClose,
      disableCloseButton = _ref.disableCloseButton,
      disableIcon = _ref.disableIcon,
      children = _ref.children,
      actions = _ref.actions,
      extra = _ref.extra,
      level = _ref.level,
      error = _ref.error,
      warning = _ref.warning,
      info = _ref.info,
      success = _ref.success,
      restProps = _objectWithoutProperties(_ref, ["className", "onClose", "disableCloseButton", "disableIcon", "children", "actions", "extra", "level", "error", "warning", "info", "success"]);

  var theme = useComponentTheme(MESSAGE_CLASS_PREFIX);
  var classNameComponents = useMessageClassNames(MESSAGE_CLASS_PREFIX, className);
  var Icon = useIconComponent({
    level: level,
    error: error,
    warning: warning,
    info: info,
    success: success
  });
  return React.createElement(MessageRoot, Object.assign({}, restProps, {
    theme: theme,
    disableCloseButton: disableCloseButton,
    level: level,
    error: error,
    warning: warning,
    info: info,
    success: success,
    className: classNameComponents.Root
  }), !disableIcon && React.createElement(MessageIconStyle, {
    theme: theme,
    level: level,
    error: error,
    warning: warning,
    info: info,
    success: success,
    className: classNameComponents.Icon
  }, function (forwardedProps) {
    return React.createElement(Icon, Object.assign({}, forwardedProps), children);
  }), React.createElement(MessageCentral, {
    theme: theme,
    className: classNameComponents.Central
  }, React.createElement(MessageContent, {
    theme: theme,
    className: classNameComponents.Content
  }, children), !!actions && React.createElement(MessageActions, {
    theme: theme,
    className: classNameComponents.Actions
  }, actions), !!extra && React.createElement(MessageExtra, {
    theme: theme,
    className: classNameComponents.Extra
  }, extra)), !disableCloseButton && React.createElement(MessageCloseButton, {
    onClick: onClose,
    theme: theme,
    className: classNameComponents.CloseButton,
    tabIndex: -1
  }, React.createElement(CancelIcon, null)));
};
Message.defaultProps = {
  disableCloseButton: false,
  disableIcon: false,
  error: false,
  warning: false,
  info: false,
  success: false
};